module.exports = {
  "sidebar.app": "Home",
  "sidebar.news": "News",
  "sidebar.horizontal": "Horizontal",
  "sidebar.horizontalMenu": "Horizontal Menu",
  "sidebar.general": "General",
  "sidebar.component": "Komponente",
  "sidebar.features": "Features",
  "sidebar.applications": "Applications",
  "sidebar.dashboard": "Dashboard",
  "sidebar.whsRecpts": "Warehouse-Quittungen",
  "sidebar.dashboard1": "Dashboard 1",
  "sidebar.dashboard2": "Dashboard 2",
  "sidebar.dashboard3": "Dashboard 3",
  "sidebar.modules": "Module",
  "sidebar.agency": "Agentur",
  "sidebar.pages": "Pages",
  "sidebar.gallery": "Galerie",
  "sidebar.pricing": "Preis",
  "sidebar.termsConditions": "Allgemeine Geschäftsbedingungen",
  "sidebar.feedback": "Feedback",
  "sidebar.report": "Bericht",
  "sidebar.faq (s)": "Faq (s)",
  "sidebar.advancedComponent": "Advance Component",
  "sidebar.blank": "Blank",
  "sidebar.session": "Sitzung",
  "sidebar.login": "Login",
  "sidebar.register": "Registrieren",
  "sidebar.lockScreen": "Bildschirm sperren",
  "sidebar.forgotPassword": "Passwort vergessen",
  "Seitenleiste 404": "404",
  "Seitenleiste 500": "500",
  "sidebar.uiComponents": "UI-Komponenten",
  "sidebar.alerts": "Alerts",
  "sidebar.appBar": "App Bar",
  "sidebar.avatars": "Avatare",
  "sidebar.buttons": "Buttons",
  "sidebar.bottomNavigations": "Bottom Navigations",
  "sidebar.badges": "Badges",
  "sidebar.cards": "Karten",
  "sidebar.cardsMasonry": "Kartenmauerwerk",
  "sidebar.chip": "Chip",
  "sidebar.dialog": "Dialog",
  "sidebar.dividers": "Teiler",
  "sidebar.drawers": "Schubladen",
  "sidebar.popover": "Popover",
  "sidebar.expansionPanel": "Expansion Panel",
  "sidebar.gridList": "Rasterliste",
  "sidebar.list": "Liste",
  "sidebar.menu": "Menü",
  "sidebar.popoverAndToolTip": "Popover & ToolTip",
  "sidebar.progress": "Fortschritt",
  "sidebar.snackbar": "Snackbar",
  "sidebar.selectionControls": "Auswahlsteuerelemente",
  "sidebar.advanceUiComponents": "Erweiterte UI-Komponenten",
  "sidebar.dateAndTimePicker": "Datums- und Uhrzeitauswahl",
  "sidebar.tabs": "Tabs",
  "sidebar.stepper": "Stepper",
  "sidebar.notification": "Benachrichtigung",
  "sidebar.sweetAlert": "Süßer Alarm",
  "sidebar.autoComplete": "Auto Complete",
  "sidebar.aboutUs": "Über uns",
  "sidebar.widgets": "Widgets",
  "sidebar.forms": "Forms",
  "sidebar.formElements": "Formularelemente",
  "sidebar.textField": "Textfeld",
  "sidebar.selectList": "Liste auswählen",
  "sidebar.charts": "Charts",
  "sidebar.reCharts": "Re Charts",
  "sidebar.reactChartjs2": "React Chartjs 2",
  "sidebar.icons": "Icons",
  "sidebar.themifyIcons": "Themify Icons",
  "sidebar.simpleLineIcons": "Einfache Zeilensymbole",
  "sidebar.materialIcons": "Material Icons",
  "sidebar.fontAwesome": "Font Awesome",
  "sidebar.tables": "Tabellen",
  "sidebar.basic": "Basic",
  "sidebar.dataTable": "Datentabelle",
  "sidebar.responsive": "Responsive",
  "sidebar.reactTable": "React Table",
  "sidebar.maps": "Karten",
  "sidebar.googleMaps": "Google Maps",
  "sidebar.leafletMaps": "Prospektkarten",
  "sidebar.inbox": "Posteingang",
  "sidebar.users": "Benutzer",
  "sidebar.userProfile1": "Benutzerprofil 1",
  "sidebar.userProfile2": "Benutzerprofil 2",
  "sidebar.userManagement": "Benutzerverwaltung",
  "sidebar.userProfile": "Benutzerprofil",
  "sidebar.userList": "Benutzerliste",
  "sidebar.calendar": "Kalender",
  "sidebar.cultures": "Kulturen",
  "sidebar.dnd": "Dnd",
  "sidebar.selectable": "Selectable",
  "sidebar.customRendering": "Benutzerdefiniertes Rendering",
  "sidebar.chat": "Chat",
  "sidebar.toDo": "ToDo",
  "sidebar.editor": "Editor",
  "sidebar.wysiwygEditor": "WYSIWYG-Editor",
  "sidebar.quillEditor": "Quill Editor",
  "sidebar.reactAce": "React Ace",
  "sidebar.dragAndDrop": "Ziehen und Ablegen",
  "sidebar.whsRecpt": "Warehouse",
  "sidebar.details": "Details",
  "sidebar.reactDragula": "Dragula reagieren",
  "sidebar.reactDnd": "React Dnd",
  "sidebar.blogManagement": "Blogverwaltung",
  "sidebar.ecommerce": "E-Commerce",
  "sidebar.shopList": "Shop List",
  "sidebar.shopGrid": "Shop Grid",
  "sidebar.invoice": "Rechnung",
  "sidebar.multilevel": "Multilevel",
  "sidebar.sublevel": "Sublevel",
  "sidebar.deleteme": "Deleteme",
  "sidebar.settings": "Einstellungen",
  "general.search": "Suche...",
  "general.streetOne": "Straße 1",
  "general.streetTwo": "Straße 2",
  "general.streetThree": "Straße 3",
  "general.city": "Stadt",
  "general.yes": "Ja",
  "general.no": "Nein",
  "general.loading": "Laden...",
  "widgets.totalEarns": "Gesamteinkommen",
  "widgets.emailsStatistics": "E-Mail-Statistik",
  "widgets.weight": "Versandgewicht (Kgs)",
  "widgets.fob": "FOB Shipped ($)",
  "widgets.totalRevenue": "Gesamtumsatz",
  "widgets.onlineVisitors": "Online Besucher",
  "widgets.trafficSources": "Verkehrsquellen",
  "widgets.RecentOrders": "Recent Orders",
  "widgets.topSellings": "Top Sellings",
  "widgets.productReports": "Produktberichte",
  "widgets.productStats": "Produktstatistiken",
  "widgets.ComposeEmail": "E-Mail verfassen",
  "widgets.employeePayroll": "Mitarbeiterabrechnung",
  "widgets.visitors": "Besucher",
  "widgets.orders": "Bestellungen",
  "widgets.orderStatus": "Bestellstatus",
  "widgets.totalSales": "Gesamtumsatz",
  "widgets.netProfit": "Nettogewinn",
  "widgets.overallTrafficStatus": "Gesamtverkehrsstatus",
  "widgets.tax": "Steuer",
  "widgets.expenses": "Ausgaben",
  "widgets.currentTime": "Aktuelle Uhrzeit",
  "widgets.currentDate": "Aktuelles Datum",
  "widgets.todayOrders": "Heute bestellt",
  "widgets.toDoList": "Aufgabenlisten",
  "widgets.discoverPeople": "Leute entdecken",
  "widgets.comments": "Kommentare",
  "widgets.newCustomers": "Neue Kunden",
  "widgets.recentNotifications": "Recent Notifications",
  "widgets.appNotifications": "App-Benachrichtigungen",
  "widgets.ratings": "Ratings",
  "widgets.newEmails": "Neue E-Mails",
  "widgets.siteVisitors": "Site-Besucher",
  "widgets.socialCompanies": "Social Companines",
  "widgets.recentActivities": "Letzte Aktivitäten",
  "widgets.recentOrders": "Recent Orders",
  "widgets.gallery": "Galerie",
  "widgets.pricing": "Preisgestaltung",
  "widgets.enterpriseEdition": "Enterprise Edition",
  "widgets.personalEdition": "Personal Edition",
  "widgets.teamEdition": "Team Edition",
  "widgets.standard": "Standard",
  "widgets.advanced": "Erweitert",
  "widgets.master": "Master",
  "widgets.Mega": "Mega",
  "widgets.logIn": "Anmelden",
  "widgets.signUp": "Anmelden",
  "widgets.lockScreen": "Bildschirm sperren",
  "widgets.alertsWithLink": "Alerts With Link",
  "widgets.additionalContent": "Zusätzlicher Inhalt",
  "widgets.alertDismiss": "Alert Dismiss",
  "widgets.uncontrolledDisableAlerts": "Unkontrollierte Alarme deaktivieren",
  "widgets.contextualAlerts": "Contextual Alerts",
  "widgets.alertsWithIcons": "Warnungen mit Symbolen",
  "widgets.Simple App Bars": "Einfache App Bars",
  "widgets.appBarsWithButtons": "App Bars mit Schaltflächen",
  "widgets.imageAvatars": "Image Avatars",
  "widgets.lettersAvatars": "Letters Avatars",
  "widgets.iconsAvatars": "Icons Avatars",
  "widgets.flatButtons": "Flache Knöpfe",
  "widgets.raisedButton": "Erhöhter Button",
  "widgets.buttonWithIconAndLabel": "Schaltfläche mit Symbol und Beschriftung",
  "widgets.floatingActionButtons": "Schwimmende Aktionsschaltflächen",
  "widgets.iconButton": "Symbolschaltfläche",
  "widgets.socialMediaButton": "Social Media Button",
  "widgets.reactButton": "React Button",
  "widgets.buttonOutline": "Button Outline",
  "widgets.buttonSize": "Schaltflächengröße",
  "widgets.buttonState": "Button State",
  "widgets.buttonNavigationWithNoLabel":
    "Schaltfläche Navigation ohne Beschriftung",
  "widgets.buttonNavigation": "Schaltflächennavigation",
  "widgets.iconNavigation": "Icon Navigation",
  "widgets.badgeWithHeadings": "Abzeichen mit Überschriften",
  "widgets.contextualVariations": "Contextual Variations",
  "widgets.badgeLinks": "Badge Links",
  "widgets.materialBadge": "Material Badge",
  "widgets.simpleCards": "Einfache Karten",
  "widgets.backgroundVariant": "Background Varient",
  "widgets.cardOutline": "Kartenumriss",
  "widgets.overlayCard": "Overlay-Karte",
  "widgets.cardGroup": "Kartengruppe",
  "widgets.cardTitle": "Kartentitel",
  "widgets.specialTitleTreatment": "Speacial Title Treatment",
  "widgets.chipWithClickEvent": "Chip with Click Event",
  "widgets.chipArray": "Chip Array",
  "widgets.listDividers": "List Dividers",
  "widgets.insetDividers": "Inset Dividers",
  "widgets.temporaryDrawers": "Temporäre Schubladen",
  "widgets.permanentDrawers": "Permanente Schubladen",
  "widgets.simpleExpansionPanel": "Einfache Erweiterungsleiste",
  "widgets.controlledAccordion": "Kontrolliertes Akkordeon",
  "widgets.secondaryHeadingAndColumns": "Sekundäre Überschrift und Spalten",
  "widgets.imageOnlyGridLists": "Rasterlisten für Bilder",
  "widgets.advancedGridLists": "Erweiterte Rasterlisten",
  "widgets.singleLineGridLists": "Einzeilige Gitterlisten",
  "widgets.simpleLists": "Einfache Listen",
  "widgets.folderLists": "Ordnerlisten",
  "widgets.listItemWithImage": "Element mit Bild auflisten",
  "widgets.switchLists": "Schalterlisten",
  "widgets.insetLists": "Inset-Listen",
  "widgets.nestedLists": "Verschachtelte Listen",
  "widgets.checkboxListControl": "Checkbox List Control",
  "widgets.pinedSubHeader": "Pined Sub Header",
  "widgets.InteractiveLists": "Interaktive Listen",
  "widgets.simpleMenus": "Einfache Menüs",
  "widgets.selectedMenu": "Ausgewähltes Menü",
  "widgets.maxHeightMenu": "Max Height Menu",
  "widgets.changeTransition": "Übergang ändern",
  "widgets.paper": "Paper",
  "widgets.anchorPlayGround": "Ankerplatz",
  "widgets.tooltip": "ToolTip",
  "widgets.positionedToolTips": "Positionierte Snackbar",
  "widgets.circularProgressBottomStart":
    "Kreisförmiger Fortschritt am unteren Anfang",
  "widgets.interactiveIntegration": "Interaktive Integration",
  "widgets.determinate": "Bestimmen",
  "widgets.linearProgressLineBar": "Lineare Fortschrittslinienleiste",
  "widgets.indeterminate": "Indeterminate",
  "widgets.buffer": "Buffer",
  "widgets.query": "Query",
  "widgets.transitionControlDirection": "Übergangssteuerungsrichtung",
  "widgets.simpleSnackbar": "Simple Snackbar",
  "widgets.positionedSnackbar": "Positionierte Snackbar",
  "widgets.contextualColoredSnackbars": "Contextual Colored Snackbars",
  "widgets.simpleCheckbox": "Einfache Checkbox",
  "widgets.indeterminateSelection": "Auswahl unterbrechen",
  "widgets.disabledCheckbox": "Deaktivierte Checkbox",
  "widgets.customColorCheckbox":
    "Kontrollkästchen für benutzerdefinierte Farbe",
  "widgets.VerticalStyleCheckbox": "Checkbox für vertikalen Stil",
  "widgets.horizontalStyleCheckbox": "Checkbox für horizontalen Stil",
  "widgets.radioButtons": "Optionsschaltflächen",
  "widgets.disabledRadio": "Deaktiviertes Radio",
  "widgets.withError": "Mit Fehler",
  "widgets.dateAndTimePicker": "Datums- und Uhrzeitauswahl",
  "widgets.defaultPicker": "Default Picker",
  "widgets.timePicker": "Time Picker",
  "widgets.weekPicker": "Wochenauswahl",
  "widgets.defaultDatePicker": "Standard-Datumsauswahl",
  "widgets.customPicker": "Benutzerdefinierte Auswahl",
  "widgets.tabs": "Tabs",
  "widgets.fixedTabs": "Fixierte Tabs",
  "widgets.basicTab": "Basisreiter",
  "widgets.wrappedLabels": "Wrapped Labels",
  "widgets.centeredLabels": "Zentrierte Beschriftungen",
  "widgets.forcedScrolledButtons": "Forced Scrolled Buttons",
  "widgets.iconsTabs": "Icons Tabs",
  "widgets.withDisableTabs": "Mit Registerkarten deaktivieren",
  "widgets.iconWithLabel": "Symbol mit Beschriftung",
  "widgets.stepper": "Stepper",
  "widgets.horizontalLinear": "Horizontal Linear",
  "widgets.horizontalNonLinear": "Horizontal nicht linear",
  "widgets.horizontalLinerAlternativeLabel":
    "Horizontal Liner Alternative Label",
  "widgets.horizontalNonLinerAlternativeLabel":
    "Horizontales Non-Liner-Alternativetikett",
  "widgets.verticalStepper": "Vertical Stepper",
  "widgets.descriptionAlert": "Description Alert",
  "widgets.customIconAlert": "Benutzerdefinierte Symbolwarnung",
  "widgets.withHtmlAlert": "With Html Alert",
  "widgets.promptAlert": "Prompt Alert",
  "widgets.passwordPromptAlert": "Warnung für Kennwortaufforderung",
  "widgets.customStyleAlert": "Alarm für benutzerdefinierten Stil",
  "widgets.autoComplete": "Auto Complete",
  "widgets.reactSelect": "React Select",
  "widgets.downshiftAutoComplete": "Automatisches Abschalten nach unten",
  "widgets.reactAutoSuggests": "Automatische Vorschlagsreaktion",
  "widgets.aboutUs": "Über uns",
  "widgets.ourVision": "Unsere Vision",
  "widgets.ourMissions": "Unsere Missionen",
  "widgets.ourMotivation": "Unsere Motivation",
  "widgets.defaultReactForm": "Defualt React Form",
  "widgets.url": "Url",
  "widgets.textArea": "Textbereich",
  "widgets.file": "Datei",
  "widgets.formGrid": "Form Grid",
  "widgets.inlineForm": "Inline-Formular",
  "widgets.inputSizing": "Input Sizing",
  "widgets.inputGridSizing": "Größe der Eingangsgitter",
  "widgets.hiddenLabels": "Versteckte Labels",
  "widgets.formValidation": "Formularüberprüfung",
  "widgets.number": "Nummer",
  "widgets.date": "Datum",
  "widgets.time": "Zeit",
  "widgets.color": "Farbe",
  "widgets.search": "Suche",
  "widgets.selectMultiple": "Mehrere auswählen",
  "widgets.inputWithSuccess": "Eingabe mit Erfolg",
  "widgets.inputWithDanger": "Eingabe mit Gefahr",
  "widgets.simpleTextField": "Einfaches Textfeld",
  "widgets.component": "Komponenten",
  "widgets.layouts": "Layouts",
  "widgets.inputAdornments": "Adorporationen eingeben",
  "widgets.formattedInputs": "Formatierte Eingaben",
  "widgets.simpleSelect": "Einfache Auswahl",
  "widgets.nativeSelect": "Native Select",
  "widgets.MultiSelectList": "Mehrfachauswahlliste",
  "widgets.lineChart": "Liniendiagramm",
  "widgets.barChart": "Balkendiagramm",
  "widgets.stackedBarChart": "Gestapeltes Balkendiagramm",
  "widgets.lineBarAreaChart": "Liniendiagrammbereich",
  "widgets.areaChart": "Flächendiagramm",
  "widgets.stackedAreaChart": "Gestapeltes Flächendiagramm",
  "widgets.verticalChart": "Vertical Chart",
  "widgets.radarChart": "Radardiagramm",
  "widgets.doughnut": "Donut",
  "widgets.polarChart": "Polardiagramm",
  "widgets.pieChart": "Kreisdiagramm",
  "widgets.bubbleChart": "Blasendiagramm",
  "widgets.horizontalBar": "Horizontale Leiste",
  "widgets.basicTable": "Basistabelle",
  "widgets.dataTable": "Datentabelle",
  "widgets.employeeList": "Mitarbeiterliste",
  "widgets.responsiveTable": "Responsive Table",
  "widgets.responsiveFlipTable": "Responsive Flip Table",
  "widgets.reactGridControlledStateMode": "React Grid Controlled State Mode",
  "widgets.productsReports": "Produktberichte",
  "widgets.taskList": "Aufgabenliste",
  "widgets.basicCalender": "Basiskalender",
  "widgets.culturesCalender": "Cultures Calender",
  "widgets.dragAndDropCalender": "Drag & Drop-Kalender",
  "widgets.selectableCalender": "Auswählbarer Kalender",
  "widgets.customRendering": "Benutzerdefiniertes Rendering",
  "widgets.customCalender": "Benutzerdefinierter Kalender",
  "widgets.searchMailList": "Mail-Liste durchsuchen",
  "components.buyNow": "Jetzt kaufen",
  "components.choose": "Wählen",
  "components.username": "Benutzername",
  "components.passwords": "Kennwörter",
  "widgets.forgetPassword": "Passwort vergessen",
  "components.signIn": "Anmelden",
  "components.dontHaveAccountSignUp": "Keine Kontoanmeldung",
  "components.enterUserName": "Benutzername eingeben",
  "components.enterEmailAddress": "E-Mail-Adresse eingeben",
  "components.confirmPasswords": "Kennwörter bestätigen",
  "components.alreadyHavingAccountSignIn": "Bereits angemeldetes Konto",
  "components.enterYourPassword": "Geben Sie Ihr Passwort ein",
  "components.unlock": "Unlock",
  "components.enterPasswords": "Kennwörter eingeben",
  "components.resetPassword": "Passwort zurücksetzen",
  "components.pageNotfound": "Seite nicht gefunden",
  "components.goToHomePage": "Zur Startseite",
  "components.sorryServerGoesWrong":
    "Entschuldigung, dass der Server nicht funktioniert",
  "components.persistentDrawer": "Persistent Drawer",
  "components.withHtml": "With Html",
  "components.prompt": "Prompt",
  "components.withDescription": "With Description",
  "components.success": "Erfolg",
  "components.passwordPrompt": "Kennwortabfrage",
  "components.warning": "Warnung",
  "components.customIcon": "Benutzerdefiniertes Symbol",
  "components.customStyle": "Benutzerdefinierter Stil",
  "components.basic": "Basic",
  "components.submit": "Submit",
  "components.compose": "Compose",
  "components.sendMessage": "Nachricht senden",
  "components.addNewTasks": "Neue Aufgaben hinzufügen",
  "components.addToCart": "In den Warenkorb",
  "components.payNow": "Jetzt bezahlen",
  "components.print": "Drucken",
  "components.cart": "Einkaufswagen",
  "components.viewCart": "Warenkorb anzeigen",
  "components.checkout": "Checkout",
  "widgets.QuickLinks": "Quick Links",
  "widgets.upgrade": "upgrade",
  "widgets.app": "App",
  "widgets.addNew": "Neu hinzufügen",
  "widgets.orderDate": "Bestelldatum",
  "widgets.status": "Status",
  "widgets.trackingNumber": "Tracking-Nummer",
  "widgets.action": "Aktion",
  "widgets.designation": "Designation",
  "widgets.subject": "subject",
  "widgets.send": "Senden",
  "widgets.saveAsDrafts": "Als Entwurf speichern",
  "widgets.onlineSources": "Online-Quellen",
  "widgets.lastMonth": "Letzter Monat",
  "widgets.widgets": "Widgets",
  "widgets.listing": "Listing",
  "widgets.paid": "bezahlt",
  "widgets.refunded": "Erstattet",
  "widgets.done": "Fertig",
  "widgets.pending": "Pending",
  "widgets.cancelled": "Abgebrochen",
  "widgets.approve": "Genehmigen",
  "widgets.following": "folgend",
  "widgets.follow": "follow",
  "Widgets.graphs & Charts": "Grafiken & Charts",
  "widgets.open": "Öffnen",
  "widgets.bounce": "Bounce",
  "widgets.spam": "Spam",
  "widgets.unset": "Unset",
  "widgets.bandwidthUse": "Bandwidth Use",
  "widgets.dataUse": "Datennutzung",
  "widgets.unsubscribe": "Abbestellen",
  "widgets.profile": "Profil",
  "widgets.messages": "Nachrichten",
  "widgets.support": "Support",
  "widgets.faq (s)": "Faq (s)",
  "widgets.upgradePlains": "Upgrade Plains",
  "widgets.logOut": "Abmelden",
  "widgets.mail": "Mail",
  "widgets.adminTheme": "Admin Theme",
  "widgets.wordpressTheme": "Wordpress Theme",
  "widgets.addToCart": "In den Warenkorb",
  "widgets.plan": "Plan",
  "widgets.basic": "Basic",
  "widgets.pro": "Pro",
  "widgets.startToBasic": "Start to Basic",
  "widgets.upgradeToPro": "Upgrade auf Pro",
  "widgets.upgradeToAdvance": "Upgrade auf Fortschritt",
  "widgets.comparePlans": "Pläne vergleichen",
  "widgets.free": "Free",
  "widgets.frequentlyAskedQuestions": "Häufig gestellte Fragen",
  "widgets.searchIdeas": "Suchideen",
  "widgets.startDate": "Startdatum",
  "widgets.endDate": "Enddatum",
  "widgets.category": "Kategorie",
  "widgets.apply": "Übernehmen",
  "widgets.yesterday": "Gestern",
  "widgets.totalOrders": "Aufträge insgesamt",
  "widgets.totalVisitors": "Gesamtzahl der Besucher",
  "widgets.typeYourQuestions": "Geben Sie Ihre Fragen ein",
  "widgets.username": "Benutzername",
  "widgets.password": "Passwort",
  "widgets.signIn": "Anmelden",
  "widgets.enterYourPassword": "Geben Sie Ihr Passwort ein",
  "widgets.alreadyHavingAccountLogin": "Bereits angemeldetes Konto",
  "widgets.composeMail": "Mail verfassen",
  "widgets.issue": "Problem",
  "widgets.recentChat": "Recent Chat",
  "widgets.previousChat": "Vorheriger Chat",
  "widgets.all": "Alle",
  "widgets.filters": "Filter",
  "widgets.deleted": "Gelöscht",
  "widgets.starred": "Markiert",
  "widgets.frontend": "Frontend",
  "widgets.backend": "Backend",
  "widgets.api": "Api",
  "widgets.simpleAppBar": "Einfache Anwendungsleiste",
  "widgets.recents": "Neuerscheinungen",
  "widgets.cardLink": "Card Link",
  "widgets.anotherLink": "Weiterer Link",
  "widgets.cardSubtitle": "Kartenuntertitel",
  "widgets.confirmationDialogs": "Bestätigungsdialoge",
  "widgets.deletableChip": "Löschbarer Chip",
  "widgets.customDeleteIconChip": "Benutzerdefinierter Löschsymbolchip",
  "widgets.openAlertDialog": "Alarmdialog öffnen",
  "widgets.openResponsiveDialog": "Responsive Dialog öffnen",
  "widgets.openSimpleDialog": "Einfacher Dialog öffnen",
  "widgets.openFormDialog": "Formulardialog öffnen",
  "widgets.follower": "Anhänger",
  "widgets.important": "Important",
  "widgets.private": "Privat",
  "widgets.openLeft": "Links öffnen",
  "widgets.openRight": "Rechts öffnen",
  "widgets.openTop": "Open Top",
  "widgets.openBottom": "Open Bottom",
  "widgets.selectTripDestination": "Reiseziel auswählen",
  "widgets.pinnedSubheaderList": "Pinned Subheader List",
  "widgets.singleLineItem": "Einzelposten",
  "widgets.optionA": "Option A",
  "widgets.optionB": "Option B",
  "widgets.optionC": "Option C",
  "widgets.optionM": "Option M",
  "widgets.optionN": "Option N",
  "widgets.optionO": "Option O",
  "widgets.customColor": "Benutzerdefinierte Farbe",
  "widgets.centeredTabs": "Zentrierte Registerkarten",
  "widgets.multipleTabs": "Mehrere Registerkarten",
  "widgets.preventScrolledButtons": "Scrolled Buttons verhindern",
  "widgets.browse": "Durchsuchen",
  "widgets.formValidate": "Form Validate",
  "widgets.code": "Code",
  "widgets.company": "Unternehmen",
  "widgets.price": "Preis",
  "widgets.change": "Ändern",
  "widgets.high": "Hoch",
  "widgets.low": "Low",
  "widgets.volume": "Volume",
  "widgets.personalDetails": "Persönliche Details",
  "widgets.occupation": "Occupation",
  "widgets.companyName": "Firmenname",
  "widgets.phoneNo": "Phone No",
  "widgets.updateProfile": "Profil aktualisieren",
  "widgets.reject": "Ablehnen",
  "widgets.exportToExcel": "Export nach Excel",
  "widgets.workWeek": "Arbeitswoche",
  "widgets.agenda": "Agenda",
  "widgets.conference": "Konferenz",
  "widgets.multilevel": "Multilevel",
  "widgets.dailySales": "Daily Sales",
  "widgets.today": "Heute",
  "widgets.campaignPerformance": "Kampagnenleistung",
  "widgets.supportRequest": "Supportanfrage",
  "widgets.usersList": "Benutzerliste",
  "widgets.lastWeek": "Letzte Woche",
  "themeOptions.sidebarOverlay": "Seitenleistenüberlagerung",
  "themeOptions.sidebarBackgroundImages": "Sidebar Background Images",
  "themeOptions.appSettings": "App-Einstellungen",
  "themeOptions.sidebarImage": "Sidebar Image",
  "themeOptions.miniSidebar": "Mini-Sidebar",
  "themeOptions.boxLayout": "Box Layout",
  "themeOptions.rtlLayout": "RTL-Layout",
  "themeOptions.darkMode": "Dark Mode",
  "themeOptions.sidebarLight": "Licht",
  "themeOptions.sidebarDark": "Dark",
  "button.cancel": "Abbrechen",
  "button.add": "Hinzufügen",
  "button.update": "Update",
  "button.reply": "Antworten",
  "button.delete": "Löschen",
  "button.yes": "Ja",
  "button.viewAll": "Alle anzeigen",
  "button.like": "Like",
  "button.assignNow": "Jetzt zuweisen",
  "button.seeInsights": "Siehe Einblicke",
  "sidebar.dateTimePicker": "Datums- und Uhrzeitauswahl",
  "components.summary": "Zusammenfassung",
  "hint.whatAreYouLookingFor": "Wonach suchst du",
  "components.yesterday": "Gestern",
  "components.last7Days": "Letzte 7 Tage",
  "components.last1Month": "Letzter 1 Monat",
  "components.last6Month": "Letzten 6 Monate",
  "components.spaceUsed": "Verwendeter Speicherplatz",
  "components.followers": "Anhänger",
  "components.trending": "Trending",
  "components.paid": "bezahlt",
  "components.refunded": "Erstattet",
  "components.done": "Fertig",
  "components.pending": "Pending",
  "components.cancelled": "Abgebrochen",
  "components.approve": "Genehmigen",
  "components.week": "Woche",
  "components.month": "Monat",
  "components.year": "Jahr",
  "components.today": "Heute",
  "components.popularity": "popularität",
  "components.email": "E-Mail",
  "components.drafts": "Entwürfe",
  "components.sent": "Gesendet",
  "components.trash": "Papierkorb",
  "components.all": "Alle",
  "components.do": "Do",
  "components.title": "Titel",
  "components.projectName": "Projektname",
  "components.companyName": "Firmenname",
  "components.openAlert": "Open Alert",
  "components.slideInAlertDialog": "Slide In Alert Dialog",
  "components.openFullScreenDialog": "Vollbild-Dialoge öffnen",
  "components.basicChip": "Basic Chip",
  "components.clickableChip": "Clickable Chip",
  "components.left": "Left",
  "components.right": "Right",
  "components.expansionPanel1": "Expansion Panel 1",
  "components.expansionPanel2": "Expansion Panel 2",
  "components.generalSetting": "Allgemeine Einstellung",
  "components.advancedSettings": "Erweiterte Einstellungen",
  "components.firstName": "Vorname",
  "components.lastName": "Nachname",
  "components.occupation": "Beruf",
  "components.phoneNo": "Phone No",
  "components.address": "Adresse",
  "components.city": "Stadt",
  "components.state": "State",
  "components.zipCode": "Postleitzahl",
  "components.social Connection": "Soziale Verbindung",
  "widgets.buyMore": "Mehr kaufen",
  "widgets.trafficChannel": "Verkehrskanal",
  "widgets.stockExchange": "Börse",
  "widgets.tweets": "Tweets",
  "widgets.ourLocations": "Unsere Standorte",
  "widgets.sales": "Verkauf",
  "widgets.to": "An",
  "widgets.shipTo": "Versenden an",
  "widgets.description": "Beschreibung",
  "widgets.unitPrice": "Stückpreis",
  "widgets.total": "Gesamt",
  "widgets.note": "Hinweis",
  "widgets.chipWithAvatar": "Chip With Avatar",
  "widgets.chipWithTextAvatar": "Chip With Text Avatar",
  "widgets.chipWithIconAvatar": "Chip With Icon Avatar",
  "widgets.customClickableChip": "Custom Clickable Chip",
  "widgets.outlineChip": "Gliederungschip",
  "widgets.disableChip": "Chip deaktivieren",
  "widgets.alertDialog": "Alert Dialog",
  "widgets.animatedSlideDialogs": "Animierte Foliendialoge",
  "widgets.fullScreenDialogs": "Vollbild-Dialoge",
  "widgets.formDialogs": "Formulardialoge",
  "widgets.simpleDialogs": "Einfache Dialoge",
  "widgets.responsiveFullScreen": "Responsive Full Screen",
  "widgets.primary": "Primär",
  "widgets.social": "sozial",
  "widgets.user": "Benutzer",
  "widgets.admin": "Admin",
  "widgets.permanentDrawer": "Permanent Drawer",
  "widgets.persistentdrawer": "Persistent Drawer",
  "widgets.switches": "Switches",
  "widgets.horizontalLinearAlternativeLabel":
    "Horizontales lineares alternatives Etikett",
  "widgets.horizontalNonLinearAlternativeLabel":
    "Horizontales nicht lineares alternatives Etikett",
  "widgets.notifications": "Notifications",
  "widgets.basicAlert": "Grundwarnung",
  "widgets.successAlert": "Erfolgswarnung",
  "widgets.warningAlert": "Warnmeldung",
  "widgets.reactAutoSuggest": "Automatische Vorschlagsreaktion",
  "widgets.components": "Komponenten",
  "widgets.multiSelectList": "Mehrfachauswahlliste",
  "widgets.contextualColoredTable": "Contextual Colored Table",
  "widgets.updateYourEmailAddress": "Aktualisieren Sie Ihre E-Mail-Adresse",
  "widgets.selectADefaultAddress": "Wählen Sie eine Standardadresse aus",
  "widgets.activity": "Aktivität",
  "widgets.basicCalendar": "Grundkalender",
  "widgets.culturesCalendar": "Kulturenkalender",
  "widgets.dragAndDropCalendar": "Drag and Drop Calendar",
  "widgets.quillEditor": "Quill Editor",
  "widgets.reactDND": "DND reagieren",
  "widgets.dragula": "Dragula",
  "button.acceptTerms": "Bedingungen akzeptieren",
  "button.reject": "Ablehnen",
  "button.addNew": "Add New",
  "button.goToCampaign": "Gehe zur Kampagne",
  "button.viewProfile": "Profil anzeigen",
  "button.sendMessage": "Nachricht senden",
  "button.saveNow": "Jetzt speichern",
  "button.pen": "Stift",
  "button.search": "Suche",
  "button.downloadPdfReport": "PDF-Bericht herunterladen",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.danger": "Gefahr",
  "button.info": "Info",
  "button.success": "Erfolg",
  "button.warning": "Warnung",
  "button.link": "Link",
  "button.smallButton": "Kleiner Button",
  "button.largeButton": "Large Button",
  "button.blockLevelButton": "Block Level Button",
  "button.primaryButton": "Primary Button",
  "button.button": "Button",
  "button.save": "Speichern",
  "button.openMenu": "Menü öffnen",
  "button.openWithFadeTransition": "Mit Überblendungsübergang öffnen",
  "button.openPopover": "Popover öffnen",
  "button.accept": "Akzeptieren",
  "button.click": "Klick",
  "button.complete": "Complete",
  "button.back": "Zurück",
  "button.next": "Next",
  "button.completeStep": "Schritt abschließen",
  "button.error": "Fehler",
  "button.writeNewMessage": "Neue Nachricht schreiben",
  "button.saveChanges": "Änderungen speichern",
  "button.addNewUser": "Neuen Benutzer hinzufügen",
  "button.more": "More",
  "hint.searchMailList": "Mail-Liste durchsuchen",
  "widgets.AcceptOrRejectWithin": "Innerhalb akzeptieren oder ablehnen",
  "widgets.quoteOfTheDay": "Zitat des Tages",
  "widgets.updated10Minago": "Vor 10 Min. aktualisiert",
  "widgets.personalSchedule": "Persönlicher Zeitplan",
  "widgets.activeUsers": "Aktive Benutzer",
  "widgets.totalRequest": "Gesamtanfrage",
  "widgets.new": "Neu",
  "widgets.ShareWithFriends": "Mit Freunden teilen!",
  "widgets.helpToShareText":
    "Helfen Sie uns, die Welt zu verbreiten, indem Sie unsere Website mit Ihren Freunden und Followern in sozialen Medien teilen!",
  "widgets.thisWeek": "Diese Woche",
  "widgets.howWouldYouRateUs": "Wie bewerten Sie uns?",
  "widgets.booking": "Buchung",
  "widgets.confirmed": "Bestätigt",
  "widgets.monthly": "Monatlich",
  "widgets.weekly": "Wöchentlich",
  "widgets.target": "Ziel",
  "widgets.totalActiveUsers": "Gesamtzahl der aktiven Benutzer",
  "sidebar.user": "Benutzer",
  "sidebar.m Miscellaneous": "Miscellaneous",
  "sidebar.promo": "Promo",
  "themeOptions.themeColor": "Designfarbe",
  "module.inbox": "Posteingang",
  "module.drafts": "Entwürfe",
  "module.sent": "Gesendet",
  "module.trash": "Papierkorb",
  "module.spam": "Spam",
  "module.frontend": "Frontend",
  "module.backend": "Backend",
  "module.api": "Api",
  "module.issue": "Problem",
  "components.emailPreferences": "Email Preferences",
  "components.myProfile": "Mein Profil",
  "sidebar.gettingStarted": "Erste Schritte",
  "widgets.deadline": "Deadline",
  "widgets.team": "Team",
  "widgets.projectManagement": "Projektmanagement",
  "widgets.latestPost": "Letzter Beitrag",
  "widgets.projectTaskManagement": "Projektaufgabenverwaltung",
  "widgets.selectProject": "Projekt auswählen",
  "widgets.activityBoard": "Activity Board",
  "widgets.checklist": "Checkliste",
  "sidebar.shop": "Shop",
  "sidebar.cart": "Einkaufswagen",
  "sidebar.checkout": "Checkout",
  "components.product": "Produkt",
  "components.quantity": "Quantity",
  "components.totalPrice": "Gesamtpreis",
  "components.removeProduct": "Produkt entfernen",
  "components.mobileNumber": "Handynummer",
  "components.address2Optional": "Adresse 2 (optional)",
  "components.country": "Land",
  "components.zip": "Zip",
  "components.saveContinue": "Speichern und fortfahren",
  "components.placeOrder": "Bestellung aufgeben",
  "components.payment": "Zahlung",
  "components.billingAddress": "Rechnungsadresse",
  "components.ShippingAddressText":
    "Die Versandadresse ist die gleiche wie die Rechnungsadresse.",
  "components.CartEmptyText": "Ihr Einkaufswagen ist leer!",
  "components.NoItemFound": "Kein Artikel gefunden",
  "components.goToShop": "Zum Shop gehen",
  "components.cardNumber": "Kartennummer",
  "components.expiryDate": "Ablaufdatum",
  "components.cvv": "CVV",
  "components.nameOnCard": "Name auf Karte",
  "components.confirmPayment": "Zahlung bestätigen",
  "sidebar.saas": "SAAS",
  "sidebar.multiLevel": "MultiLevel",
  "sidebar.level1": "Level 1",
  "sidebar.level2": "Level 2",
  "sidebar.boxed": "Boxed", // Warehouse-Details
  "whsReceiptDetails.details": "Details",
  "whsReceiptDetails.none": "NONE",
  "whsReceiptDetails.number": "Number",
  "whsReceiptDetails.adhoc": "Adhoc",
  "whsReceiptDetails.cancel": "Abbrechen",
  "whsReceiptDetails.warehouse": "Warehouse",
  "whsReceiptDetails.created": "Erstellt",
  "whsReceiptDetails.customer": "Kunde",
  "whsReceiptDetails.shipper": "Versender",
  "whsReceiptDetails.inboundCarrier": "Inbound Carrier",
  "whsReceiptDetails.invoiceDate": "Rechnungsdatum",
  "whsReceiptDetails.invoiceNumber": "Rechnungsnummer",
  "whsReceiptDetails.blNumber": "B / L-Nummer",
  "whsReceiptDetails.stated": "Stated",
  "whsReceiptDetails.actual": "Actual",
  "whsReceiptDetails.remarks": "Bemerkungen",
  "whsReceiptDetails.palletCount": "Palettenanzahl",
  "whsReceiptDetails.cartonCount": "Carton Count",
  "whsReceiptDetails.grossKgs": "Brutto (KGS)",
  "whsReceiptDetails.grossLbs": "Brutto (LBS)",
  "whsReceiptDetails.value": "Value (USD)",
  "whsReceiptDetails.salesOrder": "Kundenauftrag",
  "whsReceiptDetails.shipSet": "Ship Set",
  "whsReceiptDetails.finalizedBy": "Finalized By",
  "whsReceiptDetails.finalizedOn": "Finalized On",
  "whsReceiptDetails.finalize": "Finlize",
  "whsReceiptDetails.documents": "Dokumentanmerkungen",
  "whsReceiptDetails.unusedPouch": "Nicht verwendeter Beutel",
  "whsReceiptDetails.temperedPouch": "Tempered Pouch",
  "whsReceiptDetails.missingSignature": "Missing Signature",
  "whsReceiptDetails.missingPouch": "Fehlender Beutel",
  "whsReceiptDetails.docIssuesReslv": "Dokumentationsprobleme behoben?",
  "whsReceiptDetails.warehouseRM":
    "Fehlende Artikel des Wareneingangs aus PL (Mangel)",
  "whsReceiptDetails.missingDocuments": "Fehlende Dokumente",
  "whsReceiptDetails.packingList": "Packing List",
  "whsReceiptDetails.sli": "SLI",
  "whsReceiptDetails.pieces": "Pieces",
  "whsReceiptDetails.pieceNumber": "Stückzahl",
  "whsReceiptDetails.pieceType": "Stücktyp",
  "whsReceiptDetails.length": "Length (in)",
  "whsReceiptDetails.width": "Width (in)",
  "whsReceiptDetails.height": "Height (in)",
  "whsReceiptDetails.trackingNumbers": "Nummern verfolgen",
  "whsReceiptDetails.shipped": "Versendet",
  "whsReceiptDetails.received": "Received",
  "whsReceiptDetails.eta": "ETA",
  "whsReceiptDetails.files": "Dateien",
  "whsReceiptDetails.name": "Name",
  "whsReceiptDetails.size": "Größe",
  "whsReceiptDetails.download": "Herunterladen",
  "whsReceiptDetails.emptyFileList": "Keine Dateien!",
  "whsReceiptDetails.save": "Speichern",
  "whsReceiptDetails.edit": "edit",
  "whsReceiptDetails.lin": "LIN",
  "whsReceiptDetails.partNumber": "Teilenummer",
  "whsReceiptDetails.overage": "Überdurchschnittlich",
  "whsReceiptDetails.shortage": "Mangel",
  "whsReceiptDetails.damaged": "Beschädigt",
  "whsReceiptDetails.carton": "Carton",
  "whsReceiptDetails.pallet": "Palette",
  "whsReceiptDetails.pieceCount": "Stückzahl",
  "whsReceiptDetails.emptyTracking": "Kein Tracking verfügbar",
  "whsReceiptDetails.carrier": "Carrier",
  "whsReceiptDetails.emptyCosts": "N / A",
  "whsReceiptDetails.total": "Total",
  "whsReceiptDetails.notFinalized": "Nicht abgeschlossen",
  "whsReceiptDetails.customerPO": "Kundenbestellung",
  "whsReceiptDetails.costs": "Kosten",
  "userManagement.firstName": "Vorname",
  "userManagement.lastName": "Nachname",
  "userManagement.email": "Email"
};
